import { useMemo, useRef, useCallback } from 'react';
import './utils-ae044d92.js';
import useConstant from './useConstant.esm.js';
import { _ as _extends, m as makeEncDec } from './encdec-fa8e1134.js';
import qs from 'query-string';
import 'memoize-one';
import 'lodash.isequal';
import { u as useStableObject } from './stableUseObject-8397d805.js';

function useQueryParam(queryString, setQueryString, name, defaultValue, qpEncoder, options) {
  if (qpEncoder === void 0) {
    qpEncoder = false;
  }

  if (options === void 0) {
    options = {};
  }

  var parser = useConstant(function () {
    return makeEncDec(qpEncoder);
  });
  var opts = useStableObject(options);

  var _useMemo = useMemo(function () {
    var allParams = qs.parse(queryString);

    if (allParams[name]) {
      return [parser.decode(allParams[name]), allParams];
    } else {
      return [defaultValue, allParams];
    }
  }, [defaultValue, name, parser, queryString]),
      param = _useMemo[0],
      queryParams = _useMemo[1];

  var holder = useRef(queryParams);

  if (queryParams !== holder.current) {
    holder.current = queryParams;
  }

  var setQueryParams = useCallback(function (nextValue) {
    var _extends2;

    var currentQueryParams = holder.current;
    var queryString = qs.stringify(_extends({}, currentQueryParams, (_extends2 = {}, _extends2[name] = parser.encode(nextValue), _extends2)), opts);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    setQueryString.apply(void 0, [queryString].concat(args));
  }, [name, parser, opts, setQueryString]);
  return [param, setQueryParams];
}

export default useQueryParam;